import { render, staticRenderFns } from "./user-dashboard.vue?vue&type=template&id=08dee8ef&scoped=true&"
import script from "./user-dashboard.vue?vue&type=script&lang=js&"
export * from "./user-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./user-dashboard.vue?vue&type=style&index=0&id=08dee8ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dee8ef",
  null
  
)

export default component.exports